export const rates = {
	'2024': {
		'0-24': 0,
		'24-120': 2.23,
		'24-120specialAddress': 2.47,
		'120+': 1.12,
		'120+specialAddress': 2.47,
		bridges: {
			greatBeltBridge: {
				car: 110,
				motorbike: 110,
				publicTransport: 15,
			},
			oresundBridge: {
				car: 50,
				motorbike: 50,
				publicTransport: 8,
			},
		},
	},
	'2025': {
		'0-24': 0,
		'24-120': 2.23,
		'24-120specialAddress': 2.47,
		'120+': 1.12,
		'120+specialAddress': 2.47,
		bridges: {
			greatBeltBridge: {
				car: 110,
				motorbike: 110,
				publicTransport: 15,
			},
			oresundBridge: {
				car: 50,
				motorbike: 50,
				publicTransport: 8,
			},
		},
	},
};
